import { Injectable } from '@angular/core';
import { fromEvent, merge, Observable, timer } from 'rxjs';
import { filter, map } from 'rxjs/operators';

/** Owns the tab-local session generation and active-tab session refresh cadence. */
@Injectable({ providedIn: 'root' })
export class SessionCoordinatorService {
  private _generation = 0;
  private _lastSuccessAt = 0;

  begin(): number {
    this._lastSuccessAt = 0;
    return ++this._generation;
  }

  invalidate(): number {
    this._lastSuccessAt = 0;
    return ++this._generation;
  }

  currentGeneration(): number {
    return this._generation;
  }

  isCurrent(generation: number): boolean {
    return generation === this._generation;
  }

  markSuccess(generation: number, at = Date.now()): void {
    if (this.isCurrent(generation)) {
      this._lastSuccessAt = at;
    }
  }

  pollTriggers(): Observable<void> {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return new Observable<void>();
    }

    const interval$ = timer(60_000, 60_000);
    const visibility$ = fromEvent(document, 'visibilitychange').pipe(
      filter(() => document.visibilityState === 'visible')
    );
    const online$ = fromEvent(window, 'online');

    return merge(interval$, visibility$, online$).pipe(
      filter(() => document.visibilityState === 'visible'),
      filter(() => Date.now() - this._lastSuccessAt >= 60_000),
      map(() => undefined)
    );
  }
}
